export const IS_FETCHING = 'IS_FETCHING';
export const FETCHING_COMPLETE = 'FETCHING_COMPLETE';
export const ERROR = 'ERROR';
export const CLEAR_ERROR = 'CLEAR_ERROR';
export const CLEAR_NOTIFICATION = 'CLEAR_NOTIFICATION';
export const ADD_NOTIFICATION = 'ADD_NOTIFICAITON';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const CLEAR_ALL_ALERTS = 'CLEAR_ALL_ALERTS';
export const ADD_TOAST_NOTIFICATION = 'ADD_TOAST_NOTIFICATION';

// TODO
// Add a method to delete the error
export const removeError = (errorKey: string) => ({
  type: CLEAR_ERROR,
  errorKey,
});

export const removeNotification = (notificationKey: string) => ({
  type: CLEAR_NOTIFICATION,
  notificationKey,
});

export const addNotification = (notificationText: string) => ({
  type: ADD_NOTIFICATION,
  notificationText,
});

export const addError = (errorMessage: string) => ({
  type: ERROR,
  errorMessage,
});

export const clearAllAlerts = () => ({
  type: CLEAR_ALL_ALERTS,
});

export const addToastNotification = (value: boolean) => ({
  type: ADD_TOAST_NOTIFICATION,
  value,
});
